import React from "react";
import Character1Mailbox from "./Character1Mailbox.js"
import Character2Mailbox from "./Character2Mailbox.js"
import Character3Mailbox from "./Character3Mailbox.js"
import Character4Mailbox from "./Character4Mailbox.js"

class CharacterMailbox extends React.Component {
  state = { svg: null };

  componentDidMount() {
    const svgSupport =
      !!document.createElementNS &&
      !!document.createElementNS("http://www.w3.org/2000/svg", "svg")
        .createSVGRect;
    if (svgSupport) {
      this.setState({
        svg: "svg"
      });
    } else {
      this.setState({
        svg: "png"
      });
    }
  }
  render() {
    return (
      <div
        className={
          "option character-illustration-wrapper character-mailbox " +
          this.state.svg
        }
      >
        {this.props.characterReference === "character-1" && <Character1Mailbox/>}
        {this.props.characterReference === "character-2" && <Character2Mailbox/>}
        {this.props.characterReference === "character-3" && <Character3Mailbox/>}
        {this.props.characterReference === "character-4" && <Character4Mailbox/>}
        <svg className={"character-background character-mailbox-background"} />
      </div>
    );
  }
}

export default CharacterMailbox;



// WEBPACK FOOTER //
// ./src/components/characters/CharacterMailbox.js